"use strict";

exports.__esModule = true;
exports.NumericCellType = exports.CELL_TYPE = void 0;
var _numericType = require("./numericType");
exports.CELL_TYPE = _numericType.CELL_TYPE;
exports.NumericCellType = _numericType.NumericCellType;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/numericType/index.js
// module id = 1108
// module chunks = 0